import {
  ProjectFunction,
  ProjectItem,
  ProjectTechnology,
  ProjectType,
  ProjectTool,
  Platform,
} from '@/types';
import {
  getProjectImage,
  getProjectLogo,
  getProjectPreviewVideo,
} from '@/utils/imageUtils';
import { FunctionsData } from './functions-data';
import { TechnologiesData } from './technologies-data';
import { ToolsData } from './tools-data';
import { PlatformsData } from './platforms-data';

export const ProjectsData: ProjectItem[] = [
  // {
  //   id: 0,
  //   name: 'CocktailDB',
  //   aboutEn:
  //     'A database application that allows users to search, discover, and learn about cocktail recipes with intuitive navigation.',
  //   aboutPt:
  //     'Uma aplicação de base de dados que permite aos utilizadores pesquisar e ver informação sobre receitas de cocktails com navegação intuitiva.',
  //   descEn: 'Cocktail Recipe Database',
  //   descPt: 'Base de Dados de Receitas de Cocktails',
  //   platforms: [
  //     PlatformsData[Platform.DESKTOP],
  //     PlatformsData[Platform.MOBILE],
  //   ],
  //   img: getProjectImage('cocktaildb-logo-nobg.png', 'cocktaildb'),
  //   logo: getProjectLogo('cocktaildb-logo-nobg.png', 'cocktaildb'),
  //   backgroundColor: '137,167,103',
  //   font: 'Montserrat',
  //   url: 'https://react-projects-15-cocktails.netlify.app/',
  //   startBackgroundColor: false,
  //   type: ProjectType.ACADEMICAL,
  //   year: 2023,
  //   technologies: [
  //     TechnologiesData[ProjectTechnology.HTML],
  //     TechnologiesData[ProjectTechnology.CSS],
  //     TechnologiesData[ProjectTechnology.JAVASCRIPT],
  //   ],
  //   functions: [
  //     FunctionsData[ProjectFunction.DEVELOPED],
  //     FunctionsData[ProjectFunction.DEPLOYED],
  //   ],
  // },
  // {
  //   id: 1,
  //   name: 'MovieDB',
  //   aboutEn:
  //     'A simple database platform that allows users to search and see infomation about movies and TV shows.',
  //   aboutPt:
  //     'Uma plataforma de base de dados simples, que permite aos utilizadores pesquisar e ver informação sobre filmes e séries.',
  //   descEn: 'Movie Discovery Platform',
  //   descPt: 'Plataforma de Descoberta de Filmes',
  //   platforms: [
  //     PlatformsData[Platform.DESKTOP],
  //     PlatformsData[Platform.MOBILE],
  //   ],
  //   img: getProjectImage('movieDB.webp', 'moviedb'),
  //   logo: getProjectLogo('moviedb-logo-nobg.png', 'moviedb'),
  //   backgroundColor: '102,51,237',
  //   font: 'Montserrat',
  //   url: 'https://movie-js-db.netlify.app/',
  //   type: ProjectType.ACADEMICAL,
  //   year: 2023,
  //   technologies: [
  //     TechnologiesData[ProjectTechnology.HTML],
  //     TechnologiesData[ProjectTechnology.CSS],
  //     TechnologiesData[ProjectTechnology.JAVASCRIPT],
  //   ],
  //   functions: [
  //     FunctionsData[ProjectFunction.DEVELOPED],
  //     FunctionsData[ProjectFunction.IMPLEMENTED],
  //     FunctionsData[ProjectFunction.DEPLOYED],
  //   ],
  // },
  {
    id: 0,
    name: 'Leminflix',
    aboutEn:
      'A Netflix-clone web application for seamlessly browsing, filtering, and searching an extensive catalog of movies and TV shows.',
    aboutPt:
      'Uma aplicação web clone da Netflix para navegar, filtrar e pesquisar de forma fluida um catálogo extenso de filmes e séries.',
    descEn: 'Streaming Platform Clone',
    descPt: 'Clone de Plataforma de Streaming',
    platforms: [
      PlatformsData[Platform.DESKTOP],
      PlatformsData[Platform.MOBILE],
    ],
    img: getProjectImage('leminflix.webp', 'leminflix'),
    logo: getProjectLogo('leminflix-logo-nobg.png', 'leminflix'),
    backgroundColor: '210,29,36',
    font: 'BebasNeue',
    url: 'https://leminflix.netlify.app',
    type: ProjectType.ACADEMICAL,
    year: 2023,
    technologies: [
      TechnologiesData[ProjectTechnology.HTML],
      TechnologiesData[ProjectTechnology.CSS],
      TechnologiesData[ProjectTechnology.JAVASCRIPT],
      TechnologiesData[ProjectTechnology.REACT],
      TechnologiesData[ProjectTechnology.SCSS],
    ],
    tools: [ToolsData[ProjectTool.GIT], ToolsData[ProjectTool.PHOTOSHOP]],
    functions: [
      FunctionsData[ProjectFunction.DEVELOPED],
      FunctionsData[ProjectFunction.IMPLEMENTED],
      FunctionsData[ProjectFunction.DEPLOYED],
    ],
  },
  {
    id: 1,
    name: 'Chem',
    aboutEn:
      'A sophisticated web tool for simulating and visualizing chemical processes, featuring interactive graphs focused on titration, distillation, and related analyses.',
    aboutPt:
      'Uma ferramenta web sofisticada para simular e visualizar processos químicos, com gráficos interativos centrados em titulação, destilação e análises relacionadas.',
    descEn: 'Chemical Process Simulator',
    descPt: 'Simulador de Processos Químicos',
    platforms: [
      PlatformsData[Platform.DESKTOP],
      PlatformsData[Platform.MOBILE],
    ],
    img: getProjectImage('chem_thumbnail_1.webp', 'chem'),
    logo: getProjectLogo('chem-logo-nobg.png', 'chem'),
    video: getProjectPreviewVideo('chem_preview.mp4', 'chem'),
    client: 'Cunha&Cunha Consulting',
    backgroundColor: '68,125,46',
    font: 'Arial',
    type: ProjectType.PROFESSIONAL,
    year: 2024,
    technologies: [
      TechnologiesData[ProjectTechnology.HTML],
      TechnologiesData[ProjectTechnology.CSS],
      TechnologiesData[ProjectTechnology.JAVASCRIPT],
      TechnologiesData[ProjectTechnology.TYPESCRIPT],
      TechnologiesData[ProjectTechnology.REACT],
      TechnologiesData[ProjectTechnology.SCSS],
    ],
    tools: [ToolsData[ProjectTool.GIT]],
    functions: [
      FunctionsData[ProjectFunction.PLANNED],
      FunctionsData[ProjectFunction.DEVELOPED],
      FunctionsData[ProjectFunction.IMPLEMENTED],
      FunctionsData[ProjectFunction.DEPLOYED],
    ],
  },
  {
    id: 3,
    name: 'João Lemos',
    aboutEn: 'My professional portfolio, this website',
    aboutPt: 'O meu portfólio profissional, este site.',
    descEn: 'Personal Portfolio Site',
    descPt: 'Site de Portfólio Pessoal',
    platforms: [
      PlatformsData[Platform.DESKTOP],
      PlatformsData[Platform.MOBILE],
    ],
    logo: getProjectLogo('joao-lemos-logo_n3.png', 'joaolemos'),
    backgroundColor: '239,117,42',
    font: 'Montserrat',
    startBackgroundColor: false,
    type: ProjectType.FREELANCE,
    year: 2025,
    technologies: [
      TechnologiesData[ProjectTechnology.HTML],
      TechnologiesData[ProjectTechnology.CSS],
      TechnologiesData[ProjectTechnology.JAVASCRIPT],
      TechnologiesData[ProjectTechnology.TYPESCRIPT],
      TechnologiesData[ProjectTechnology.REACT],
      TechnologiesData[ProjectTechnology.SCSS],
    ],
    tools: [
      ToolsData[ProjectTool.GIT],
      ToolsData[ProjectTool.PHOTOSHOP],
      ToolsData[ProjectTool.VITE],
    ],
    functions: [
      FunctionsData[ProjectFunction.PLANNED],
      FunctionsData[ProjectFunction.DESIGNED],
      FunctionsData[ProjectFunction.DEVELOPED],
      FunctionsData[ProjectFunction.IMPLEMENTED],
      FunctionsData[ProjectFunction.OPTIMIZED],
      FunctionsData[ProjectFunction.DEPLOYED],
    ],
  },

  {
    id: 2,
    name: 'Procheck Productions',
    aboutEn:
      'The official website for Procheck Productions, a Portuguese studio delivering high-quality photo, video, and sound production services.',
    aboutPt:
      'O website oficial da Procheck Productions, um estúdio português que oferece serviços de produção de foto, vídeo e som de alta qualidade.',
    descEn: 'Production Studio Website',
    descPt: 'Website de Estúdio de Produção',
    platforms: [
      PlatformsData[Platform.DESKTOP],
      PlatformsData[Platform.MOBILE],
    ],
    img: getProjectImage('procheck_home.webp', 'procheck'),
    logo: getProjectLogo('prochecklogo-nobg.png', 'procheck'),
    video: getProjectPreviewVideo('procheck_preview.mp4', 'procheck'),
    client: 'Procheck Productions',
    backgroundColor: '243,55,50',
    font: 'Montserrat',
    startBackgroundColor: false,
    type: ProjectType.PROFESSIONAL,
    year: 2024,
    technologies: [
      TechnologiesData[ProjectTechnology.HTML],
      TechnologiesData[ProjectTechnology.CSS],
      TechnologiesData[ProjectTechnology.JAVASCRIPT],
      TechnologiesData[ProjectTechnology.TYPESCRIPT],
      TechnologiesData[ProjectTechnology.REACT],
      TechnologiesData[ProjectTechnology.SCSS],
    ],
    tools: [
      ToolsData[ProjectTool.GIT],
      ToolsData[ProjectTool.PHOTOSHOP],
      ToolsData[ProjectTool.VITE],
    ],
    functions: [
      FunctionsData[ProjectFunction.PLANNED],
      FunctionsData[ProjectFunction.DESIGNED],
      FunctionsData[ProjectFunction.DEVELOPED],
      FunctionsData[ProjectFunction.IMPLEMENTED],
      FunctionsData[ProjectFunction.OPTIMIZED],
      FunctionsData[ProjectFunction.DEPLOYED],
    ],
  },
];
